import { useQuery } from '@apollo/client'
import { GetLocationProducts, GetLocationProductsVariables } from '../../types'
import { GET_PRODUCTS } from './operations'

export const useProducts = () => {
  const { data, loading: isProductsDataLoading } = useQuery<
    GetLocationProducts,
    GetLocationProductsVariables
  >(GET_PRODUCTS, {
    variables: {
      pagination: { from: 0, length: 100 },
    },
  })

  return {
    products: data?.products.products,
    isProductsDataLoading,
  }
}
